<template>
  <div class="footerbox">
  
    <div class="footer-t">
      <div class="footer-t-l">
        <div class="footer-main-t">
          <div class="footer-logo">
            <img src="../../img/logo.png" alt="" />
          </div>
          <div class="footer-ewm">
            <svg
              t="1677571374076"
              class="icon"
              viewBox="0 0 1228 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="12889"
            >
              <path
                d="M819.4048 347.648c12.288 0 24.2176 0.6144 36.4032 1.792C828.3136 167.936 656.9984 28.0576 449.6896 28.0576 223.232 28.0576 39.6288 194.9696 39.6288 400.896c0 115.1488 57.4464 218.0608 147.5584 286.5152-11.4688 59.904-25.8048 138.5984-23.7568 135.936 3.1744-1.1776 82.3808-46.848 132.1984-76.8 47.5648 17.408 99.4816 27.2384 154.0608 27.2384 5.7344 0 11.3152-0.1536 17.0496-0.3072a329.216 329.216 0 0 1-9.6256-79.616c-0.1024-191.1296 162.0992-346.112 362.2912-346.112z m-208.6912-121.6512c28.3648 0 51.2512 23.7568 51.2512 53.1456 0 29.44-22.9888 53.3504-51.2 53.3504-28.3136 0-51.3024-23.9616-51.3024-53.3504 0-29.3888 22.9888-53.1456 51.2512-53.1456zM295.936 332.4928c-28.3648 0-51.2-23.9616-51.2-53.3504 0-29.3888 22.8864-53.1456 51.2-53.1456 28.2624 0 51.2 23.7568 51.2 53.1456 0 29.44-22.9376 53.3504-51.2 53.3504z m893.2352 349.8496c0-172.288-157.2864-311.9104-351.3856-311.9104-194.0992 0-351.488 139.7248-351.488 311.9104 0 172.288 157.3888 312.064 351.488 312.064a387.8912 387.8912 0 0 0 147.8656-28.9792c46.3872 25.7024 96.8704 52.736 99.3792 53.5552 1.792 1.9968-8.192-48.384-18.944-99.2768 75.2128-57.4464 123.0848-142.336 123.0848-237.3632z m-483.2256-68.4544c-28.3136 0-51.3024-23.808-51.3024-53.1968 0-29.3376 22.9888-53.2992 51.3024-53.2992 28.2624 0 51.2 23.9616 51.2 53.2992 0 29.3888-22.9376 53.1968-51.2 53.1968z m256.2048 0c-28.2624 0-51.3536-23.808-51.3536-53.1968 0-29.3376 23.04-53.2992 51.3536-53.2992 28.2624 0 51.3536 23.9616 51.3536 53.2992 0 29.3888-23.04 53.1968-51.3536 53.1968z"
                fill="#000000"
                p-id="12890"
              ></path>
            </svg>
            <div class="ewm">
              <img :src=imgurl+footer.pub_code alt="">
              <svg t="1687672752076" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="9068" width="200" height="200"><path d="M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z" fill="#ffffff" p-id="9069"></path></svg>
            </div>
          </div>
        </div>
        <div class="footer-main-b">
          <div class="footer-main-b-top">
            <p v-if="data[1]">
              <span v-if='data[1].title'>{{data[1].title}}：</span
              >{{ data[1].address }}
              
            </p>
            <p v-if="data[1].phone"><span>客服电话：</span>{{ data[1].phone }}</p>
            <p v-if="data[1].email"><span>联系邮箱：</span> {{ data[1].email }}</p>
           
          </div>
          <div class="footer-main-b-buttom">
            <p v-if="data[2]">
              <span v-if="data[2].title">{{data[2].title}}：</span
              >{{ data[2].address }}
            </p>
            <p v-if="data[2].phone"><span>客服电话：</span>{{ data[2].phone }}</p>
            <p v-if="data[2].email"><span>联系邮箱：</span> {{ data[2].email }}</p>
            <p v-if="data[0]">
              <span v-if="data[0]">{{data[0].title}}：</span>{{ data[0].address }}
            </p>
         
            <p v-if="data[0].phone"><span>客服电话：</span>{{ data[0].phone }}</p>
            <p v-if="data[0].email"><span>联系邮箱：</span> {{ data[0].email }}</p>
          </div>
          </div>
          <div class="footer-background">
            <img src="../../img/showout.png" alt="">
          </div>
        </div>
       

      <div class="footer-t-r">
        <div class="ul">
          <div class="li li-t">会员中心</div>
          <div class="li-b">
       <div class="li" v-for="(i,index) in footerList[0]" @click=click(i.path) :key="index">{{i.name}}</div>
        </div>
      </div>
        <div class="ul">
          <div class="li li-t">购物指南</div>
          <div class="li-b">
        <div class="li" v-for="(i,index) in footerList[1]" @click=click(i.path) :key="index">{{i.name}}</div>
        </div>
      </div>
        <div class="ul">
          <div class="li li-t">配送政策</div>
          <div class="li-b">
           <div class="li" v-for="(i,index) in footerList[2]" @click=click(i.path) :key="index">{{i.name}}</div>
        </div>
      </div>
        <div class="ul">
          <div class="li li-t">售后服务</div>
          <div class="li-b">
        <div class="li" v-for="(i,index) in footerList[3]" @click=click(i.path) :key="index"> {{i.name}}</div>
        </div>
      </div>
      </div>
    </div>
    <div class="footer-b">
      <div class="footer-b-box">
     <div @click="goIcp()" class="icp"> {{ footer.icp }}</div>
       <div>{{footer.copyright}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import {address_list,system} from '../../request/api'
export default {
  
  data(){
    return{
      footerList:[
         [
          
          {
            name:'积分商城',
            path:'Mall'
          },{
            name:'会员说明',
            path:'Description'
          },
          {
            name:'隐私政策',
            path:'Privacy'
          },{
            name:'账号服务条款',
            path:'Clause'
          }
        ],
        [{
          name:'付款方式',
          path:'Termsofpayment'
        },
          {
          name:'购买流程',
          path:'Purchaseprocess'
        },
        {
          name:'订单处理',
          path:'Orderprocessing'
        },
        {
          name:'常见问题',
          path:'Shoppingproblem'
        },],
        [
        {
          name:'配送说明',
          path:'Distributioninstructions'
        },
       
        {
          name:'验货签收',
          path:'Checkandreceive'
        },
        {
          name:'常见问题',
          path:'Q&A'
        },
        ],
        [{
          name:'退还/换货',
          path:'Returngoods'
        },
        {
          name:'退款说明',
          path:'Refundinstructions'
        },
        {
          name:'发票说明',
          path:'Invoicespecification'
        },
        {
          name:'售后联系方式',
          path:'Aftersalescontact'
        },
      ],
      
      ],
      data:'',
      footer:'',
      imgurl:'https://admin.zxbiotech.cn',
    }
  },
  methods:{
    click(n){
      this.$router.push(n)
        document.body.scrollTop = 0;
	document.documentElement.scrollTop = 0;
      sessionStorage.setItem('getMenu', n)
      this.$emit('footer',1);
    },
    goIcp(){
      location.href='https://beian.miit.gov.cn'
    }
  },
  mounted(){
    address_list({is_index:1}).then((res)=>{
      
      this.data=res.data.data
    })
    system({id:1}).then((res)=>{
      
      this.footer=res.data.data
    })
  }
}
</script>
<style scoped>
@media screen and (min-width: 820px) and (max-width: 1300px){
  
}
@media screen and (min-width: 300px) and (max-width: 820px){ 
  .ewm{
    top: -5.5rem !important;
  }
  .ewm img{
    height: 4rem !important;
  }
  .footerbox{
    height: auto !important;
  }
  .footer-t-r .li{
    padding-bottom: 5px !important;
  }
  .footer-b{
    padding: 0 0.5rem !important;
  }
  .footer-ewm{
    width: 2rem !important;
    height: 2rem !important;
    margin-right: 5px;
  }
  .footer-main-b{
    position: relative;
    z-index: 5;
  }
  .footer-b div{
    height: auto !important;
    font-size: 12px !important;
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .footer-main-t{
    position: relative;
    z-index: 5;
  }
  .footer-ewm svg{
    width: 1.5rem !important;
    height: auto !important;
  }
  .footer-t{
    padding: 70px 3rem 0 3.25rem !important;
  }
  .footer-t-r{
    margin-top: 20px;
  }
  .li-t{
    font-size: 20px !important;
  }
  .li-b .li{
    font-size: 14px !important;
    width: 120px !important;
  }
  .footer-t-r .ul{
    width: auto !important;
    padding-right: 0 !important;
  }
  .li-b{
    display: flex;
    flex-wrap: wrap;
  }
  .footer-t-r{
    flex-direction: column;
  }

  .footer-t{
    flex-direction: column;
  }
  .footer-t-l{
    height: auto !important;
    width: auto  !important;
  }
  .footer-background{
    width: 100%;
    height: 100% !important;
  }
  .footer-background img{
    width: 100% !important;
    height: 100% !important;
  }
  .footer-main-b-top p{
    font-size: 14px !important;
  }
  .footer-main-b-top p span{
    font-size: 16px !important;
  }
  .footer-main-b-buttom p{
    font-size: 14px !important;
  }
  .footer-main-b-buttom p span{
    font-size: 16px !important;
  }
}
.icp:hover{
  cursor: pointer;
}
.footer-ewm{
  position: relative;
}
.footer-ewm:hover .ewm{
  display: flex;
}
.ewm{
  position: absolute;
  top: -1.5rem;
  display: none;
 
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.ewm img{
  height: 1.25rem;
}
.footer-main-t{
  position: relative;
  z-index: 400;
}
.footer-b div{
  font-family: 'Alibaba PuHuiTi-Regular';
}
.footer-main-b-top{
  font-family: 'Alibaba PuHuiTi-Medium';
}
.footer-main-b-buttom{
  font-family: 'Alibaba PuHuiTi-Medium';
}
.li-b .li{
  font-family: 'Alibaba PuHuiTi-Regular';
}
.li-t{
  font-family: 'Alibaba PuHuiTi-Medium';
}
.li:hover{
  cursor: pointer;
}
.footerbox {
  height: 100vh;
  width: 100%;
  background: url(../../img/footer.png) 100% 100%;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.footer-t {
  padding: 2.975rem 3rem 0 3.25rem;
  display: flex;
  justify-content: space-between;
  
}
.footer-t-l {
 
  width: 5.15rem;
 position: relative;
}
.footer-background{
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
}
.footer-background img{
   height: 100%;
   width: 100%;
}


.footer-main-t {
  display: flex;
  justify-content: space-between;
  margin: 0.5rem 0.5rem 0 0.5rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px dashed rgba(255, 255, 255, 0.2);
}
.footer-logo img {
}
.footer-ewm {
  height: 0.5rem;
  width: 0.5rem;
  background: #fff;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.footer-ewm svg {
  width: 0.3rem;
  height: 0.25rem;
}
.footer-main-b {
  padding: 0.5rem;
  font-size: 0.2rem;
}

.footer-main-b p {
  color: gray;
}
.footer-main-b p span {
  color: #fff;
}
.footer-t-r {
  display: flex;
}
.footer-t-r .ul {
  padding-right: 1.7rem;
  width: 1.5rem;
}
.footer-t-r .ul:last-child {
  padding-right: 0rem !important;
}

.footer-t-r .li {
  padding-bottom: 0.6rem;
  font-size: 0.25rem;
  color: rgba(255, 255, 255, 0.4);
}
.footer-t-r .li-t {
  padding-bottom: 0.8125rem;
  color: #ffffff;
  font-size: 0.3rem;
}
.footer-b{
    padding: 0 3.25rem;
}
.footer-b-box{
    height: 1rem;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-top: 1px solid gray;
    color: #fff;
}
.footer-b-box div{
  padding-left: 1rem;
}
</style>


// WEBPACK FOOTER //
// src/components/footer/footer.vue